<template>
  <div class="app-payment-information">
    <slot name="txtBefore"></slot>
    <BankAccountInformation
      v-if="isBankAccount"
      :bank-account="payment"
    >
      <template #headline><slot name="headline"></slot></template>
      <template #lblOwner><slot name="lblOwnerBankAccound"></slot></template>
      <template #lblIban><slot name="lblIbanBankAccount"></slot></template>
      <template #txtAfter><slot name="txtAfterBankAccount"></slot></template>
    </BankAccountInformation>

    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import BankAccountInformation from './BankAccountInformation'
export default {
  name: 'PaymentInformation',
  components: { BankAccountInformation },
  computed: {
    isBankAccount () {
      if (this.payment && typeof this.payment.type !== 'undefined') {
        return this.payment.type === 'bankAccount'
      }

      return false
    }
  },
  props: {
    payment: {
      type: Object
    }
  }
}
</script>
